export const PAYMENT_PROVIDERS = {
  ADYEN: 'adyen',
  ALIPAY: 'alipay',
  VGS: 'vgs',
  DELAYED: 'delayed',
  DLOCAL: 'dlocal',
  CHECKOUTCOM: 'checkoutcom',
  TRANSDEV: 'transdev',
  OXXO_DIRECT: 'oxxo_direct',
  MERCADOPAGO: 'mercadopago',
  FALLBACK_PROVIDER: 'fallbackProvider',
} as const

export type PaymentProviderValue = (typeof PAYMENT_PROVIDERS)[keyof typeof PAYMENT_PROVIDERS]
